import React, {useEffect, useContext} from 'react';
import {ViewDataContext} from '../../commons/context/view/ViewDataContext';
import AgeingDataUI from "./AgeingDataUI";
import {FiltersStateContext} from "../../commons/context/FiltersStateContext";
import {getRefreshInterval, isINRegion} from "../../util/CommonUtils";
import {useDeviceLayout} from "../../commons/context/DeviceLayoutContext";

export const AgeingData = () => {

    let search = window.location.search;
    let params = new URLSearchParams(search);
    let stationCode = params.get('stationCode');
    const {viewModel, dispatch} = useContext(ViewDataContext)
    const {selectedFilterValues} = useContext(FiltersStateContext)
    const {spacingInset_shorthand2} = useDeviceLayout();

    useEffect(() => {

        constructState(selectedFilterValues)
        dispatch({ type: 'LOAD_VIEW', data:{filters: selectedFilterValues , stationCode, view : "AGEING_VIEW" , leg : selectedFilterValues.leg ? selectedFilterValues.leg.toUpperCase() : "FORWARD", dispatcher: dispatch, isCPTFilter: false}});
        const interval = setInterval(() => {
            
            constructState(selectedFilterValues)
            //check for inactive tabs
            if (!document.hidden)   
            {        
                dispatch({ type: 'LOAD_VIEW', data:{filters: selectedFilterValues , stationCode, view : "AGEING_VIEW" , leg : selectedFilterValues.leg ? selectedFilterValues.leg.toUpperCase() : "FORWARD", dispatcher: dispatch, isCPTFilter: false}});
            }      
    }, getRefreshInterval());
    return () => clearInterval(interval);}, isINRegion() ? [selectedFilterValues.startPDD, selectedFilterValues.endPDD, selectedFilterValues.packageTypes_Reverse, selectedFilterValues.leg, selectedFilterValues.shipDateStart, selectedFilterValues.shipDateEnd] : [selectedFilterValues.startPDD, selectedFilterValues.endPDD, selectedFilterValues.packageTypes_Reverse, selectedFilterValues.leg]);

    return (

        <AgeingDataUI data = {viewModel.metricResult} isLoading = {viewModel.isLoading} viewTypeForStation = {viewModel.viewTypeForStation} isRtsAgeingGenericLabelsEnabled = {viewModel.rtsAgeingGenericLabelsEnabled} spacingInset_shorthand2={spacingInset_shorthand2}/>
    )
}

const constructState = (selectedFilterValues) => {

    var values = {

        startPDD : selectedFilterValues.startPDD,
        endPDD : selectedFilterValues.endPDD,
        leg : selectedFilterValues.leg,
        packageTypes_Reverse : selectedFilterValues.packageTypes_Reverse
    }


    //Redirect to search path
    var path = window.location.href.split("ageingBoard")[0];
    return window.location.replace( path + "ageingBoard/"+ JSON.stringify(values).replace('/','%2f'));
}


// WEBPACK FOOTER //
// ./src/components/ageing/AgeingData.js